export default "__VITE_ASSET__5fRafKxD__"